<template>
  <div class="subPanel" v-if="!notToRenderOnTypes.includes(type)">
    <button class="expandPanel" @click="collapse">
      <p>{{ parseTranslation(ADVANCED_SETTINGS) }}</p>
      <span :class="{ active: collapseRenderer }">
        <Arrow />
      </span>
    </button>
    <div v-if="collapseRenderer" class="collapsePanel">
      <div v-for="advancedOption in optionsToRender(type)" :key="advancedOption">
        <component
          :is="getComponent(advancedOptionToRenderConfig[advancedOption].type)"
          :id="
            `question-${question_index}-group-${questions_groups_index}-advanced-${advancedOption}`
          "
          :advanced_option="advancedOption"
          :question_index="question_index"
          :questions_groups_index="questions_groups_index"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Arrow from '@/components/imgs/ArrowExpandGroup'

import Checkbox from './Inputs/Checkbox'
import Select from './Inputs/Select'
import SwitchInput from './Inputs/SwitchInput'
import TextInput from './Inputs/TextInput'
import NumberInput from './Inputs/Number'

import CustomOption from './custom/index.vue'

import { questionsConfig } from '@/utils/questions'
import { advancedOptionToRenderConfig } from '@/utils/advancedOptions'

import * as translationIndex from './index.translations'

const { default: translations, ...translationKeys } = translationIndex

export default {
  name: 'Renderer',
  components: {
    Checkbox,
    Select,
    SwitchInput,
    TextInput,
    NumberInput,
    Arrow,
    CustomOption,
  },

  data() {
    return {
      translations,
      ...translationKeys,
      advancedOptionToRenderConfig,
      collapsePanel: false,
      collapseRenderer: false,
      notToRenderOnTypes: [],
    }
  },

  props: {
    type: {
      type: String,
      default: '',
    },
    question_index: {
      required: true,
      type: Number,
    },
    questions_groups_index: {
      required: true,
      type: Number,
    },
    expandAll: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['darkmode']),
  },

  watch: {
    expandAll() {
      this.collapseRenderer = !!this.expandAll
    },
  },

  methods: {
    collapse() {
      this.collapseRenderer = !this.collapseRenderer
    },

    optionsToRender(type) {
      const { advancedOptions, advancedOrder } = questionsConfig[type]

      return advancedOrder.filter(option => Object.keys(advancedOptions).includes(option))
    },

    getComponent(type) {
      switch (type) {
        case 'boolean':
          return 'Checkbox'
        case 'select':
          return 'Select'
        case 'binary-with-toggle':
          return 'SwitchInput'
        case 'numeric-input':
          return 'NumberInput'
        case 'text-input':
          return 'TextInput'
        case 'custom':
          return 'CustomOption'

        default:
          return console.error(
            `${type} ${this.translations[this.language][this.DEFAULT_SWITCH]}`,
          )
      }
    },
  },
}
</script>

<style scoped lang="scss">
.expandPanel {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border: none;
  width: 100%;
  cursor: pointer;
  font-size: inherit;
  background: none;

  &:focus {
    outline: none;
  }

  p {
    @include tipography(16);
    font-weight: bold;
    white-space: nowrap;
  }

  span {
    @include flexAlignCenter;
    svg {
      @include boxSizing(15);
    }

    margin-left: 10px;
    transition: all 0.3s ease-in;
    transform: rotate(180deg);
    margin-top: 5px;

    &.active {
      transform: rotate(0);
    }
  }
  &::after,
  &::before {
    content: '';
    display: block;
    width: 40px;
    height: 1px;
    background: $white;
    margin: 0 10px 0 0;
  }
  &::after {
    width: 100%;
    margin: 0 0 0 10px;
  }
  .light & {
    p {
      color: $gray-6;
    }

    &::after,
    &::before {
      background: $gray-5;
    }
  }
}
.collapsePanel {
  animation: growDown 400ms ease-in-out forwards;
  transform-origin: top center;

  > div {
    padding: 5px 10px;
  }
}
</style>
